import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "useful-notes-at-revision-time",
  title: "How to Take Notes During the Semester That Are Actually Useful at Revision Time",
  description:
    "The Cornell system adapted for DU lectures. Handling fast-talking professors, organizing textbook readings, and structuring notes so you aren't starting from scratch in study leave.",
  pubDate: "2026-05-20",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "study-systems",
  tags: ["study-systems", "note-taking", "revision", "academic-habits", "cornell-notes"],
  readMinutes: 9,
  heroEyebrow: "Systems · Note Craft",
};

export function Body() {
  return (
    <>
      <p>
        Effective lecture notes serve as the primary bridge between weekly syllabus readings published on{" "}
        <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
          du.ac.in
        </a>{" "}
        and final end-semester exam evaluation conducted at{" "}
        <a href="https://exam.du.ac.in/" target="_blank" rel="noopener noreferrer">
          exam.du.ac.in
        </a>
        .
      </p>

      <h2>The Adapted Cornell System for DU Lectures</h2>
      <div className="border border-rule bg-card p-5 my-6 text-sm">
        <strong className="mono-label text-grade">3-Column Note Template</strong>
        <ul className="mt-2 space-y-2">
          <li>
            <strong>Left Cue Column (25% Width):</strong> Record potential exam questions, key terms, author names, and diagram labels.
          </li>
          <li>
            <strong>Main Notes Area (75% Width):</strong> Capture mathematical derivations, step-by-step proofs, and professor emphasis points.
          </li>
          <li>
            <strong>Bottom Summary Container (2–3 Lines):</strong> Write a 2-sentence synthesis immediately following class to lock in long-term memory.
          </li>
        </ul>
      </div>

      <h2>Related Note-Taking Guides</h2>
      <p>
        Turn your semester notes into revision tools using our guides on{" "}
        <a href="/blog/one-page-cheat-sheets-that-work" className="font-semibold underline text-grade">
          One-Page Cheat Sheets
        </a>{" "}
        and{" "}
        <a href="/blog/active-recall-theory-subjects" className="font-semibold underline text-grade">
          Active Recall for Theory Subjects
        </a>
        .
      </p>
    </>
  );
}


